export enum EditEquipmentTab {
    Equipment = 0,
    Schedule = 1,
}
